<template>
  <div>
    <v-row class="mt-n3">
      <v-col cols="12">
        <span>ต้องการลา</span>
        <span class="text--primary font-weight-black">
          {{
            form.LeaveBeginDayStatusID === 'ALL'
              ? 'เต็มวัน'
              : form.LeaveBeginDayStatusID === 'AM'
              ? 'ครึ่งเช้า'
              : 'ครึ่งบ่าย'
          }}</span
        >

        <span
          v-if="
            !(form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay) &&
              form.LeaveFinishDayStatusID !== form.LeaveBeginDayStatusID
          "
        >
          กับอีก
          <span class="text--primary font-weight-black">{{
            form.LeaveFinishDayStatusID === 'ALL'
              ? 'เต็มวัน'
              : form.LeaveFinishDayStatusID === 'AM'
              ? 'ครึ่งเช้า'
              : 'ครึ่งบ่าย'
          }}</span>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-n5">
      <v-col cols="8">
        <span>วันที่ </span>
        <span class="text--primary font-weight-black">
          {{ beginDateText }}</span
        >
        <span
          v-if="!(form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay)"
          class="text--primary font-weight-black"
        >
          - {{ finishDateText }}
        </span>
        <span
          v-if="!(form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay)"
        >
          ( รวม {{ form.LeaveAmountDayAll }} วัน )</span
        >
      </v-col>
      <v-col cols="4" class="text-end">
        <span
          class="text-h5 mr-2"
          :class="
            form.LeaveAmountDay > 0
              ? 'primary--text text--darken-2 font-weight-black'
              : 'error--text'
          "
          >{{ form.LeaveAmountDay }}</span
        ><span>วันทำการ</span>
      </v-col>
    </v-row>
    <v-row class="mt-n6 mb-n4" v-if="otherData.overLimitDay > 0">
      <v-col cols="6">
        <span class="error--text">จำนวนวันลาเกินสิทธิ์</span>
      </v-col>
      <v-col cols="6" class="text-end">
        <span class="text-h6 mr-2 font-weight-black error--text ">{{
          otherData.overLimitDay
        }}</span
        ><span class="error--text">{{ otherData.leaveDayName }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    otherData: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    beginDateText: {
      type: String,
      default: ''
    },
    finishDateText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
